import Curtain from './curtain.js';

var ImageZoom = {

	init: function () {

		$(document).on('click', 'a[rel="image-zoom"]', function (event) {
			event.preventDefault();

			var imageURI = $(this).attr('href'),
			    image    = $('.image-zoom img[src*="' + imageURI + '"]');

			if (image.length) {
				ImageZoom.show(image);
			} else {
				ImageZoom.load(imageURI);
			}
		});

		// Close by clicking on image or outside it

		$(document).on('click', '#curtain, .image-zoom a', function (event) {
			event.preventDefault();
			ImageZoom.hide();
		});

		// Close by pressing Esc

		$(document).on('keyup.imageZoom', function (event) {
			if (event.keyCode === 27) {
				ImageZoom.hide();
			}
		});
	},

	load: function (imageURI) {

		// Create markup and load image

		var container = $(document.createElement('div')).addClass('image-zoom loading grow').spin('medium','#666').prependTo($('body')),
		    closeBtn  = $(document.createElement('a')).attr({'href': '#', 'title': 'Close'}).prepend('<i />').prependTo(container),
		    image     = $(document.createElement('img')).attr({'src': imageURI, 'alt': ''}).prependTo(closeBtn);

		$(image).on('load', function () {
			ImageZoom.show(image);
		});
	},

	show: function (image) {
		Curtain.show();
		image.parents('.image-zoom').show();
		ImageZoom.realign(image);
	},

	reset: function (image) {
		image.parents('.image-zoom').css({
			'top': 0,
			'left': 0
		});
		image.css({
			'width':  'auto',
			'height': 'auto'
		});
	},

	realign: function (image) {

		var container = image.parents('.image-zoom'),
		    offset    = 10,  // doubled image border (1px) + popup padding (5px)
		    scale     = 0.95,
		    imgWidth,
		    imgHeight;

		// Reset image size and position to recalculate dimensions after window resize

		container.removeClass('loading').spin(false);
		ImageZoom.reset(image);

		// Scale image if it's bigger than 95% of screen

		imgWidth  = $(image)[0].naturalWidth / 2;
		imgHeight = $(image)[0].naturalHeight / 2;

		if ((imgWidth * (1 / scale) + offset) >= $(window).width()) {
			$(image).css({
				width: function () {
					return ($(window).width() - offset) * scale;
				},
				height: 'auto'
			});
		} else if ((imgHeight * (1 / scale) + offset) >= $(window).height()) {
			$(image).css({
				width: 'auto',
				height: function () {
					return ($(window).height() - offset) * scale;
				}
			});
		} else {
			$(image).css({
				width: imgWidth,
				height: imgHeight
			});
		}

		// Calculate image position after scaling it with CSS

		container.css({
			'top':  ($(window).height() - ($(image).height() + offset)) / 2,
			'left': ($(window).width()  - ($(image).width()  + offset)) / 2
		});
	},

	hide: function () {
		ImageZoom.reset($('.image-zoom:visible img'));
		$('.image-zoom').hide();
		Curtain.hide();
	}

};

$(document).ready(function () {
	ImageZoom.init();
});

$(window).on('resize', function () {
	var openImage = $('.image-zoom:visible img');

	if (openImage.length) {
		ImageZoom.realign($(openImage));
	}
});
